import { IataAirline } from "../../iata/objects/iataAirline";
import { IataAirport } from "../../iata/objects/iataAirport";
import { Author } from "../../user/objects/author";
import { ClientBranchCompany } from "./company";

export enum codeType {
    OS = 'OS',
    SK = 'SK'
}

export interface CompanyCode {
    id: number;
    code_type: codeType;
    code_value: string;
    code_value_additional: string;
    iata_airline: IataAirline | null;
    start_date: Date | null;
    end_date: Date | null;
    iata_airport: IataAirport | null;
    created_date: Date;
    modified_date: Date;
    creator: null | Author;
    last_author: null | Author;
    client_branch: ClientBranchCompany | null | any;
}